<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },
  data(){
    return{
      formData: {
        id: null,
        is_active: 1,
        status: 1,
      },
      errorData: [],
      visible: false,
      disabled: false,
      is_upload: false,
      fileList: [],
      uploadUrl: "",
      url: ""
    }
  },
  methods:{
    show(data) {
      if (data) {
        this.formData = data
      }else {
        this.formData = {
          id: null,
          is_active: 1
        }
      }
      this.is_upload = false
      this.url = process.env.NODE_ENV === 'development' ? window.Glob.meterDev : window.Glob.meterApi
      this.uploadUrl = this.url + '/meter/MeterNonAdvance/upload?login_name=' + localStorage.getItem('login') + '&token=' + localStorage.getItem('token')
      this.errorData = []
      this.visible = true
      this.disabled = false
    },
    handleDialogClose() {
      this.visible = false
      this.formData = {
        id: null,
        is_active: 1
      }
      this.$emit('close')
    },
    handleSubmit() {
      if (this.errorData && this.errorData.length > 0) {
        this.$message.error('请检查数据')
        return
      }
      if (!this.formData.month) {
        this.$message.error('请选择所属月份')
        return
      }
      this.disabled = true
      this.$myhttp.post(this.url + '/meter/MeterNonAdvance/save', this.formData).then(resp => {
        let res = resp.data
        this.disabled = false
        if(res.code == 1) {
          this.$message.success(res.msg)
          this.handleDialogClose()
        }else {
          this.$message.error(res.msg)
        }
      })
    },
    handleSuccess(response) {
      if (response.code == 1) {
        if (response.data.error && response.data.error.length > 0) {
          this.errorData = response.data.error
        }
        this.is_upload = true
        this.formData.data = response.data.data
      }else {
        this.againUpload()
        this.$message.error(response.msg)
      }
    },
    againUpload() {
      this.fileList = []
    }
  }
}
</script>

<template>
  <el-dialog
    :visible.sync="visible"
    :title="formData.id ? '添加数据' : '添加数据'"
    append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    @close="handleDialogClose"
    :z-index="9999"
    width="60%"
  >
    <el-form ref="form" :model="formData" label-width="120px" size="mini" style="margin-right: 20px;">
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属月份" required>
            <el-date-picker
              v-model="formData.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择所属月份">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="上传数据" required>
            <el-upload
              v-model:file-list="fileList"
              :action="uploadUrl"
              :limit="1"
              :on-success="handleSuccess"
            >
              <el-button type="primary" v-if="!is_upload">上传数据文件</el-button>
              <el-button type="primary" v-if="is_upload" @click="againUpload">重新上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="errorData && errorData.length > 0">
          <el-form-item label="错误数据"></el-form-item>
        </el-col>
        <el-col :span="24" v-if="errorData && errorData.length > 0">
          <el-table :data="errorData" border>
            <el-table-column prop="index_label" label="错误行" width="180"> </el-table-column>
            <el-table-column prop="error" label="错误提示">
              <template slot-scope="scope">
                <sapn style="color: red;">{{ scope.row.error }}</sapn>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>

    <template #footer>
      <el-button size="small" @click="handleDialogClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit" :disabled="disabled">保存</el-button>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/meterNonAdvance/save.vue